<header class="shell-header">
  <!-- Collapses the sidebar to an icon rail. aria-expanded describes the
       sidebar it controls, not this button. -->
  <button
    pButton
    type="button"
    class="shell-header__nav-toggle"
    severity="secondary"
    [text]="true"
    [rounded]="true"
    [attr.aria-expanded]="!sidebar.collapsed()"
    aria-controls="shell-sidebar"
    [attr.aria-label]="'sidebar.collapse' | translate"
    (click)="sidebar.toggle()"
  >
    <i class="pi pi-bars" aria-hidden="true"></i>
  </button>

  <!-- The application is the first step of the trail rather than a separate
       brand next to it: two elements both saying "SAPHIR Web" and both linking
       home would be one too many. -->
  <nav class="shell-header__breadcrumb" [attr.aria-label]="'header.breadcrumb' | translate">
    <ol>
      @for (crumb of crumbs(); track crumb.url; let last = $last) {
        <li [class.shell-header__crumb--root]="$first">
          @if (last) {
            <span aria-current="page">{{ crumb.titleKey | translate }}</span>
          } @else {
            <a [routerLink]="crumb.url">{{ crumb.titleKey | translate }}</a>
          }
        </li>
      }
    </ol>
  </nav>

  <button
    pButton
    type="button"
    class="shell-header__palette"
    severity="secondary"
    [text]="true"
    [rounded]="true"
    [attr.aria-label]="'palette.open' | translate"
    (click)="openPalette()"
  >
    <i class="pi pi-search" aria-hidden="true"></i>
  </button>

  <!-- The permissions of the open module: how many the user holds of those the
       module knows, and the list on request. Hidden on the shell's own screens,
       where there is no module to ask about. -->
  @if (showsPermissions()) {
    <button
      pButton
      type="button"
      class="shell-header__permissions"
      severity="secondary"
      [text]="true"
      [rounded]="true"
      aria-haspopup="menu"
      [attr.aria-label]="'header.permissions.show' | translate"
      (click)="permissionsMenu.toggle($event)"
    >
      <i class="pi pi-key" aria-hidden="true"></i>
      <span class="shell-header__permissions-count">{{ permissionSummary() }}</span>
    </button>
    <p-menu
      #permissionsMenu
      [model]="permissionItems()"
      [popup]="true"
      styleClass="shell-header__permissions-menu"
    >
      <ng-template #item let-item>
        <span class="p-menu-item-link shell-header__permission">
          <i class="p-menu-item-icon" [class]="item.icon ?? 'pi pi-fw'" aria-hidden="true"></i>
          <span class="p-menu-item-label">{{
            item.id === 'permission-none' ? (item.label | translate) : item.label
          }}</span>
        </span>
      </ng-template>
    </p-menu>
  }

  <!-- A toggle button rather than a switch: `aria-pressed` states plainly
       whether dark mode is on, and the icon shows what pressing does. -->
  <button
    pButton
    type="button"
    class="shell-header__theme"
    severity="secondary"
    [text]="true"
    [rounded]="true"
    [attr.aria-pressed]="isDark()"
    [attr.aria-label]="(isDark() ? 'header.theme.toLight' : 'header.theme.toDark') | translate"
    (click)="toggleTheme()"
  >
    <i class="pi" [class.pi-moon]="!isDark()" [class.pi-sun]="isDark()" aria-hidden="true"></i>
  </button>

  <!-- Last in the row, like in the UMC: it is set once and then ignored,
       unlike the actions beside it. The trigger shows the language in use;
       the menu lists every language in its own words. -->
  <button
    pButton
    type="button"
    class="shell-header__language"
    severity="secondary"
    [text]="true"
    [rounded]="true"
    aria-haspopup="menu"
    [attr.aria-label]="'header.language.change' | translate"
    (click)="languageMenu.toggle($event)"
  >
    <i class="pi pi-globe" aria-hidden="true"></i>
    <span class="shell-header__language-code">{{ languageCode() }}</span>
  </button>
  <p-menu
    #languageMenu
    [model]="languageItems()"
    [popup]="true"
    styleClass="shell-header__language-menu"
  />
</header>
